import { Typography } from "@material-ui/core"
import MobileStepper from "@material-ui/core/MobileStepper"
import { withStyles } from "@material-ui/core/styles"
import { hexToRGBA } from "../../../utils"
import {
  NewStyledHolder,
  translateToFontConfig,
} from "../../Dashboard/components/walkthroughs/components/design/components/simulator/utils"
import { MODULE_TYPES } from "../../Dashboard/components/walkthroughs/components/design/constants"
import VStack from "../VStack"

export default function DotCarousel({
  totalSteps,
  activeStep,
  ui,
  carousal,
  counter,
  onModuleSelection,
  moduleType,
}) {
  const CustomStepper = withStyles((theme) => ({
    root: {
      background: "none",
      backgroundColor: "transparent",
    },
    dot: {
      backgroundColor: hexToRGBA(carousal.d_icolor, carousal.d_opacity),
      height: `${carousal.radius * 2}px`,
      width: `${carousal.radius * 2}px`,
      marginRight:
        ui.layout_type === "default"
          ? `${carousal.dots_dist - carousal.radius * 2}px`
          : `${carousal.dots_dist - 2}px`,
    },
    dotActive: {
      backgroundColor: hexToRGBA(carousal.d_acolor, carousal.d_opacity),
      height: `${carousal.radius * 2}px`,
      width: `${carousal.radius * 2}px`,
      marginRight:
        ui.layout_type === "default"
          ? `${carousal.dots_dist - carousal.radius * 2}px`
          : `${carousal.dots_dist - 2}px`,
    },
  }))(MobileStepper)
  return (
    <VStack
      align="center"
      spacing={0}
    >
      {/* Counter */}
      {ui.has_counter && (
        <NewStyledHolder
          selected={moduleType === MODULE_TYPES.EXPLAINER_CAROUSEL_COUNTER}
          onClick={(e) => {
            e.stopPropagation()
            onModuleSelection(e, MODULE_TYPES.EXPLAINER_CAROUSEL_COUNTER)
          }}
        >
          <Typography
            style={{
              ...translateToFontConfig(counter),
            }}
          >
            {counter.text}
          </Typography>
        </NewStyledHolder>
      )}

      {/* Dots */}
      {ui.carousal.dots && (
        <NewStyledHolder
          selected={moduleType === MODULE_TYPES.EXPLAINER_CAROUSEL_DOT}
          onClick={(e) => {
            e.stopPropagation()
            onModuleSelection(e, MODULE_TYPES.EXPLAINER_CAROUSEL_DOT)
          }}
          style={{
            marginBottom:
              ui.layout_type === "default" ? carousal?.bottom_dist : 0,
          }}
        >
          <CustomStepper
            variant="dots"
            steps={totalSteps}
            position="static"
            activeStep={activeStep}
          />
        </NewStyledHolder>
      )}
    </VStack>
  )
}
